import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    BooleanField,
    DateField,
    EditButton,
    FunctionField,
    Pagination,
} from 'react-admin';
import { Chip } from '@mui/material';

const PlatformChip = ({ record }: any) => {
    if (!record?.platform) return null;
    const isIos = record.platform === 'ios';
    return (
        <Chip
            label={isIos ? 'iOS' : 'Android'}
            color={isIos ? 'primary' : 'success'}
            size="small"
        />
    );
};

export const AppVersionList = () => (
    <List
        pagination={<Pagination rowsPerPageOptions={[]} />}
        perPage={10}
        exporter={false}
        empty={false}
        actions={false}
    >
        <Datagrid bulkActionButtons={false} rowClick={false}>
            <FunctionField label="resources.app-versions.fields.platform" render={(record: any) => <PlatformChip record={record} />} />
            <TextField source="latestVersion" />
            <TextField source="minimumVersion" />
            <BooleanField source="enabled" />
            <TextField source="appIdentifier" />
            <DateField source="updatedAt" showTime />
            <EditButton />
        </Datagrid>
    </List>
);
